export default "__VITE_ASSET__CPRv4RtE__"